import { BalanceAdjustmentModel } from 'api-hooks/transactions/balance-adjustment';
import React from 'react';

import { BalanceAdjustmentFormType } from '../components/form-type';

interface Props {
  balanceAdjustment?: BalanceAdjustmentModel;
}

export default function useGetDefaultValues(props: Props) {
  const { balanceAdjustment } = props;

  const defaultValues = React.useMemo<BalanceAdjustmentFormType>(() => {
    return {
      date: balanceAdjustment?.date || new Date(),
      tempDate: balanceAdjustment?.date || new Date(),
      needApproval: false,
      balanceableId: balanceAdjustment?.balanceable.id || null,
      type: balanceAdjustment?.type || null,
      amount: balanceAdjustment?.amount || 0,
      userType: balanceAdjustment?.balanceableType || '',
      description: balanceAdjustment?.description || '',
      balance: balanceAdjustment?.balance || 0,
      number: balanceAdjustment?.number || '',
      refId: balanceAdjustment?.refId,
    };
  }, [balanceAdjustment]);

  return defaultValues;
}
